export default {
	"billContent": {
		"isRequired": "是否必填",
		"limit": "限定值",
		"defaultValue": "默认值",
		"fixedValue": "固定值",
		"otherStyle": "其他",
		"RangeValue": "值范围"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/product/product.js